import { ThemeName } from "@kaggle/core";
import { kernelStorageClient } from "../../../../../api/services";
import { NotebookActionKey, ThemeActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";
import { ActionKey, SessionAction } from "../../../actions/session";
import { ThemeAction } from "../../../actions/theme";
import { getJupyterUrlThemeName } from "../../../selectors/jupyter";

// If the theme was persisted to disk prior, this will set it.
const persistedThemeName = kernelStorageClient.readThemeName();

// If inside jupyter, this will be populated with the initial theme.
const urlThemeName = getJupyterUrlThemeName(window.location.search);

// TODO(cochamberlain): Combine the various actions in actions/session.
export const themeName = (
  state: ThemeName = urlThemeName || persistedThemeName || "light",
  action: SessionAction | ThemeAction | NotebookAction
) => {
  switch (action.type) {
    case ActionKey.SET_SESSION_STATE:
      return action.payload.session.themeName;
    case ThemeActionKey.SET_THEME:
      return action.payload.themeName;
    case NotebookActionKey.SET_DRAFT_SPEC:
      if (!persistedThemeName) {
        return "light";
      }
      return state;
    default:
      return state;
  }
};
